import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider, App as AntdApp } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { AppRoutes } from './router/AppRoutes';
import { queryClient } from './lib/query-client';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
      // theme={{
      //   token: {
      //     colorPrimary: '#1677ff',
      //     colorLinkHover: '#3b82f6',
      //   },
      // }}
      >
        <StyleProvider>
          <BrowserRouter>
            <NuqsAdapter>
              <AntdApp>
                <AppRoutes />
              </AntdApp>
            </NuqsAdapter>
          </BrowserRouter>
        </StyleProvider>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
